/* eslint-env browser */
'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('p-queue'),
    PQueue = _require.default;

var HTTP = require('ipfs-utils/src/http');

var debug = require('debug');

var log = debug('ipfs:preload');
log.error = debug('ipfs:preload:error'); // browsers limit concurrent connections per host,
// we don't want preload calls to exhaust the limit (~6)

var httpQueue = new PQueue({
  concurrency: 4
});

module.exports = function preload(url, options) {
  log(url);
  options = options || {};
  return httpQueue.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res, reader, _yield$reader$read, done;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return HTTP.get(url, {
              signal: options.signal
            });

          case 2:
            res = _context.sent;
            reader = res.body.getReader();
            _context.prev = 4;

          case 5:
            if (!true) {
              _context.next = 14;
              break;
            }

            _context.next = 8;
            return reader.read();

          case 8:
            _yield$reader$read = _context.sent;
            done = _yield$reader$read.done;

            if (!done) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return");

          case 12:
            _context.next = 5;
            break;

          case 14:
            _context.prev = 14;
            reader.releaseLock();
            return _context.finish(14);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4,, 14, 17]]);
  })));
};